module.exports = __webpack_public_path__ + "img/ERC-alt.8e44a276.svg";